<div class="columns small-12 medium-6" data-masonry-item="">
  <div *ngIf="internetProduct.fon">
    <a
      href="javascript:void(0)"
      (click)="openUrlOrApp(internetProduct.fon, pageRouter)"
      class="rs-link-no-decoration"
      data-tms-event="link-click"
      data-tms-link-zone="internet options"
      attr.data-tms-link-name="{{ 'internet.public.wifi.label' | translate }}"
      data-tms-link-url="/public-wifi"
    >
      <div class="panel rs-panel-clickable rs-bg-grey1">
        <div class="rs-flex-row rs-flex-middle">
          <div class="rs-flex-column">
            <p class="rs-txt-purple rs-font-pxB">
              <i
                class="icon-Mobility-insurance icon-2x rs-margin-right1 rs-txt-s6"
                aria-hidden="true"
              ></i
              >{{ 'internet.public.wifi.label' | translate }}
            </p>
          </div>
          <div class="rs-flex-column rs-flex-shrink rs-flex-middle">
            <span class="rs-panel-clickable-arrow" aria-hidden="true"></span>
          </div>
        </div>
      </div>
    </a>
  </div>
</div>
